export enum AddOnId {
    User = "prod_Pk88yAxInCNcJw" as any,
    License = "prod_Pk87ocAtUMVH3r" as any,
    Organization = "prod_PGuPe5srk1EG8X" as any,
}